import { API } from "../../Services";

export const customerWallet = (id) =>{
    return (dispatch) =>{
        dispatch({
            type:"FETCH_WALLET",
        })
         API.customerWallet(id).then((res)=>{
            let data = JSON.parse(JSON.stringify(res)).data
            if(Array.isArray(data)){
                data = null
            }
            setTimeout(()=>{
                dispatch({
                    type:"RECEIVE_WALLET",
                    payload:data,
                })
            },1000)
        }).catch((err)=>{
            dispatch({
                type:"ERROR_WALLET",
            })
        })
    }
}